'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getRoot;

function getRoot(state, namespace) {
    if (!namespace || typeof namespace != 'string') return state;

    var modules = namespace.split('/');
    var len = modules.length;

    for (var i = 0; state && i < len; i++) {
        state = state[modules[i]];
    }return state;
}